import Component from '@glimmer/component';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validateNumber } from 'ember-changeset-validations/validators';

/*
  args
    - model
    - onClose()
*/

const WeeklyGoalValidation = {
  weeklyGoal: validateNumber({
    gte: 0,
    integer: true,
    allowBlank: true,
    message: 'Weekly Goal must be a positive whole number',
  }),
};

export default class extends Component {
  constructor() {
    super(...arguments);

    this.changeset = new Changeset(
      this.args.model,
      lookupValidator(WeeklyGoalValidation),
      WeeklyGoalValidation,
    );
  }

  @service fundsService;

  changeset;
  @tracked saving = false;
  @tracked saveError;
  @tracked showValidationErrors = false;

  @action
  async save() {
    if (this.saving) {
      return;
    }
    this.saving = true;
    this.showValidationErrors = true;
    await this.changeset.validate();
    if (this.changeset.get('isValid')) {
      try {
        if (
          isEmpty(this.changeset.get('weeklyGoal')) ||
          this.changeset.get('weeklyGoal') == 0
        ) {
          this.changeset.set('weeklyGoal', null);
        }
        await this.fundsService.confirmValidFundToken();
        await this.changeset.save();
        this.args.onClose();
      } catch (error) {
        this.saveError = error;
        this.saving = false;
      }
    } else {
      this.saving = false;
    }
  }
}
